module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar value = resourceData.value || '-'\nvar rowAttributes = (rowResourceData || {}).attributes || {}\nvar tsType = rowAttributes.tsType || 'monthly'\nvar ts = (resourceData || {}).value\nif(ts){\nvar pickerConfigList = (model.config || {}).pickerConfigList || {}\nif(pickerConfigList[tsType]){\nvar pickerConfig = pickerConfigList[tsType].airDateTimePickerConfig || {}\nif(pickerConfig.momentDateFormat){\nvalue = utils.moment(ts, pickerConfig.momentDataDateFormat).format(pickerConfig.momentDateFormat)\n}\n}\n}\n%>\n<span><%= value %></span>"
  , __filename = "components/templates/artCrm/cooperation/table-dateColumn.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var value = resourceData.value || '-'
var rowAttributes = (rowResourceData || {}).attributes || {}
var tsType = rowAttributes.tsType || 'monthly'
var ts = (resourceData || {}).value
if(ts){
var pickerConfigList = (model.config || {}).pickerConfigList || {}
if(pickerConfigList[tsType]){
var pickerConfig = pickerConfigList[tsType].airDateTimePickerConfig || {}
if(pickerConfig.momentDateFormat){
value = utils.moment(ts, pickerConfig.momentDataDateFormat).format(pickerConfig.momentDateFormat)
}
}
}

    ; __line = 15
    ; __append("\n<span>")
    ; __line = 16
    ; __append(escapeFn( value ))
    ; __append("</span>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/artCrm/cooperation/table-dateColumn.ejs

}